import { apiClient, type SiteSelectListExEntity } from '@/libs/api'

export const fetchSites = async (
  query: { tenantKey: string; dcId?: number },
  signal?: AbortSignal
): Promise<SiteSelectListExEntity[]> => {
  const { tenantKey, dcId } = query
  const { data } = await apiClient._tenant(tenantKey).sites.$get({
    query: dcId ? { dcId } : undefined,
    config: {
      signal
    }
  })
  return data
}
